import { IGeneratedFiles } from '../../types/models';

export const GENERATED_FILES_URL: IGeneratedFiles = {
  inputs: '/generated_files/input_consolidation',
  outputs: '/generated_files/output_consolidation',
};
